import type { ColDef, ValueGetterParams } from 'ag-grid-community'
import type { IReview } from '~/types/review'

import TextCellRenderer from '~/components/CellRenderers/TextCellRenderer'
import { dateColDef, textAndTranslationColDef, ratingColDef, textColDef } from '~/utils/table'

const columns: ColDef[] = [
  dateColDef({
    field: 'created_at',
    headerName: 'Date',
    valueGetter: ({ data }: ValueGetterParams<IReview>): number => (data ? data.created_at * 1000000 : 0),
  }),
  textColDef(TextCellRenderer, {
    field: 'app_version',
    headerName: 'App version',
  }),
  textColDef(TextCellRenderer, {
    field: 'username',
    headerName: 'Username',
  }),
  textAndTranslationColDef({
    field: 'title&title_en',
    headerName: 'Title translated',
    minWidth: 200,
    valueGetter: ({ data }: ValueGetterParams<IReview>): { original: string; translation: string } | null => {
      if (data) {
        const { title, title_en } = data as IReview
        return {
          original: title,
          translation: title_en,
        }
      }
      return null
    },
  }),
  textAndTranslationColDef({
    field: 'content&content_en',
    headerName: 'Content translated',
    minWidth: 400,
    valueGetter: ({ data }: ValueGetterParams<IReview>): { original: string; translation: string } | null => {
      if (data) {
        const { content, content_en } = data as IReview
        return {
          original: content,
          translation: content_en,
        }
      }
      return null
    },
  }),
  ratingColDef({
    field: 'rating',
  }),
  textAndTranslationColDef({
    field: 'replies',
    headerName: 'Response',
    valueGetter: ({ data }: ValueGetterParams<IReview>): { original: string; translation: string } | null => {
      if (data) {
        if (data && data.replies.length > 0) {
          const { replies } = data

          return {
            original: replies[0].content,
            translation: replies[0].content_en,
          }
        }
      }

      return null
    },
  }),
]

export default columns
